import { IntlProvider as ReactIntlProvider } from "react-intl";

const IntlProvider = props => {
  return <ReactIntlProvider {...props}>{props.children}</ReactIntlProvider>;
};

export default IntlProvider;
